module.exports = __webpack_public_path__ + "img/Bereitstellungsrau_mit_Führungsstelle.05d80d0b.svg";